/**
 * Firebase Auth client — initializes the SDK and exposes the auth instance.
 *
 * Config values são públicos (Firebase é seguro by design — auth tokens são
 * o que controla acesso, não a chave). Vêm via VITE_FIREBASE_* env vars
 * setadas no build.
 */
import { initializeApp, type FirebaseApp } from "firebase/app";
import {
  GoogleAuthProvider,
  browserLocalPersistence,
  getAuth,
  setPersistence,
  type Auth,
} from "firebase/auth";

const config = {
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY ?? "",
  authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN ?? "",
  projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID ?? "",
  storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET ?? "",
  messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID ?? "",
  appId: import.meta.env.VITE_FIREBASE_APP_ID ?? "",
};

export const firebaseConfigured = Boolean(config.apiKey && config.projectId);

let app: FirebaseApp | null = null;
let authInstance: Auth | null = null;

export function getFirebaseApp(): FirebaseApp {
  if (!firebaseConfigured) {
    throw new Error(
      "Firebase não configurado — defina VITE_FIREBASE_* no .env ou no build",
    );
  }
  if (!app) {
    app = initializeApp(config);
  }
  return app;
}

export function getFirebaseAuth(): Auth {
  if (!authInstance) {
    authInstance = getAuth(getFirebaseApp());
    // Persistência cross-tab/refresh
    void setPersistence(authInstance, browserLocalPersistence);
  }
  return authInstance;
}

export const googleProvider = new GoogleAuthProvider();
// hd hint não enforce; apenas sugestão de seleção
googleProvider.setCustomParameters({
  prompt: "select_account",
});
